import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  fetchSpecialistsAsync,
  handleLoadingState,
  saveSpecialistsAsync,
  specialistsSelector,
} from '../../../lib/dataLayer';
import { isLoadingSelector } from '../../../store/app/selectors';
import SpecialistPage from '../components/SpecialistPage';

const mapStateToProps = state => ({
  specialists: specialistsSelector(state),
  isLoading: isLoadingSelector(state),
});

const mapDispatchToProps = {
  onMount: () => handleLoadingState(fetchSpecialistsAsync),
  onSave: saveSpecialistsAsync,
  onContinue: () => push('/diagnosis'),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SpecialistPage);



// WEBPACK FOOTER //
// ./src/modules/SpecialistPage/containers/SpecialistPageContainer.js